import styled from "styled-components";
import { Button as ButtonPrimitive } from "react-aria-components";

export { Input } from "../TextInputV2/TextInputV2.styled";

export const SlotWrapper = styled.div`
  display: contents;
`;

export const HiddenButton = styled(ButtonPrimitive)`
  display: none;
`;
